import { api, api_earn } from './utils';

export async function fetchUserBalances(address: string) {
	if (!address) return;
	const response = await api('get', 'snx-core/user-balances?userAddress=' + address);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchAuxillaryBalances(address: string) {
	if (!address) return;
	const response = await api_earn('get', `users/${address}/balances/v3`);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}
